import data from '../../database/events.json'
export default data